import React from 'react';

import { Wrapper } from './Block.jsx';
import Name from '../utility/Name.jsx';
import TypeConfig from '../utility/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

function BaseButtonComponent(props) {
    let design, wrapperStyle;
    let alignment = 'center';
    let fullWidth = false;
    const contentContainerStyle = { backgroundColor: TypeConfig.defaultBackgroundColor, borderCollapse: 'separate' };
    const contentStyle = {};
    const buttonStyle = { letterSpacing: 'normal', lineHeight: '100%', textAlign: 'center', textDecoration: 'none' };
    const innerStyle = {};
    if (props.blockConfig) {
        if (props.blockConfig.block) {
            Utilities.mapStyleConfigProps(contentContainerStyle, props.blockConfig.block, (propName, propValue, propUnit) => {
                switch (propName) {
                    case 'backgroundColor':
                        if (propValue) {
                            innerStyle.backgroundColor = propValue;
                            wrapperStyle = { backgroundColor: propValue };
                        }
                        return true;
                    case 'buttonColor':
                        if (propValue) {
                            contentContainerStyle.backgroundColor = propValue;
                        }
                        return true;
                    case 'design':
                        design = propValue;
                        return true;
                    case 'fontFamily':
                        if (propValue) {
                            contentStyle[propName] = propValue;
                        }
                        return true;
                    case 'color':
                    case 'textAlign':
                        if (propValue) {
                            buttonStyle[propName] = propValue;
                        }
                        return true;
                    case 'fontSize':
                        if (propValue && propUnit) {
                            contentStyle[propName] = `${propValue}${propUnit}`;
                        }
                        return true;
                    case 'isBold':
                        if (propValue) {
                            buttonStyle.fontWeight = 'bold';
                        }
                        return true;
                    case 'isItalic':
                        if (propValue) {
                            buttonStyle.fontStyle = 'italic';
                        }
                        return true;
                    case 'isUnderline':
                        if (propValue) {
                            buttonStyle.textDecoration = 'underline';
                        }
                        return true;
                    case 'letterSpacing':
                    case 'lineHeight':
                        if (propValue && propUnit) {
                            buttonStyle[propName] = `${propValue}${propUnit}`;
                        }
                        return true;
                    default:
                        return props.onShouldMapStyleConfigProp && !props.onShouldMapStyleConfigProp(propName);
                }
            });
        }
        if (props.blockConfig.layout) {
            Utilities.mapStyleConfigProps(contentStyle, props.blockConfig.layout, (propName, propValue, propUnit) => {
                switch (propName) {
                    case 'alignment':
                        alignment = propValue;
                        return true;
                    case 'fullWidth':
                        fullWidth = propValue;
                        return true;
                    case 'marginBottom':
                    case 'marginLeft':
                    case 'marginRight':
                    case 'marginTop':
                        if (propValue && propUnit) {
                            innerStyle[propName.replace('margin', 'padding')] = `${propValue}${propUnit}`;
                        }
                        return true;
                }
            });
        }
    }
    if (!design) {
        design = props.defaultText;
    }
    if (props.builder) {
        buttonStyle.pointerEvents = 'none';
    }
    const designProps = {
        className: 'mcnButton',
        style: buttonStyle,
        title: design || ''
    }
    if (props.link) {
        design = <a href={props.link} target="_blank" {...designProps}>{design}</a>
    } else {
        design = <span {...designProps}>{design}</span>
    }
    let content = (
        <td
            align={fullWidth ? 'center' : alignment}
            className="mcnButtonBlockInner"
            style={innerStyle}
            valign="top">
            <table
                border="0"
                cellPadding="0"
                cellSpacing="0"
                className="mcnButtonContentContainer"
                style={contentContainerStyle}
                width={fullWidth ? '100%' : undefined}>
                <tbody>
                    <tr>
                        <td
                            align={buttonStyle.textAlign}
                            className="mcnButtonContent"
                            style={contentStyle}
                            valign="middle">
                            {design}
                        </td>
                    </tr>
                </tbody>
            </table>
        </td>
    );
    if (props.useWrapper != false) {
        content = (
            <Wrapper {...props} className="mcnButtonBlock" style={wrapperStyle}>
                {content}
            </Wrapper>
        );
    }
    return content;
}
const BaseButtonTypeConfig = {
    defaultDesign: (defaultText) => `<p class="p" style="margin:0;padding:0;text-align:center;"><span style="color:#ffffff;font-family:Arial, sans-serif;font-size:16px;font-weight:bold;">${defaultText || 'Shop Now'}</span></p>`,
    panel: {
        block: function (defaultText) {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Display Text',
                        fullWidth: true,
                        group,
                        name: 'design',
                        type: 'text',
                        value: defaultText
                    },
                    {
                        display: 'Text Properties',
                        group,
                        id: 'textProps',
                        type: 'header'
                    },
                    {
                        display: 'Font Family',
                        group,
                        name: 'fontFamily',
                        options: TypeConfig.options.fontFamily(),
                        type: 'dropdown',
                        value: TypeConfig.defaultFontFamily
                    },
                    {
                        display: 'Font Size',
                        group,
                        name: 'fontSize',
                        options: TypeConfig.options.measurement(),
                        type: 'measurement',
                        value: { value: '16', unit: 'px' }
                    },
                    {
                        display: 'Line Height',
                        group,
                        name: 'lineHeight',
                        options: TypeConfig.options.measurement(),
                        type: 'measurement'
                    },
                    {
                        display: 'Letter Spacing',
                        group,
                        name: 'letterSpacing',
                        options: TypeConfig.options.measurement(),
                        type: 'measurement'
                    },
                    {
                        display: 'Color',
                        group,
                        name: 'color',
                        showAlpha: false,
                        type: 'color',
                        value: '#ffffff'
                    },
                    {
                        display: 'Text Alignment',
                        group,
                        name: 'textAlign',
                        options: TypeConfig.options.alignment(),
                        type: 'dropdown',
                        value: 'center'
                    },
                    {
                        display: 'Bold',
                        group,
                        name: 'isBold',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        display: 'Italic',
                        group,
                        name: 'isItalic',
                        type: 'checkbox',
                        value: false
                    },
                    {
                        display: 'Underline',
                        group,
                        name: 'isUnderline',
                        type: 'checkbox',
                        value: false
                    },
                    {
                        fullWidth: true,
                        group,
                        type: 'spacer-short'
                    },
                    {
                        display: 'Background/Border Properties',
                        group,
                        id: 'buttonProps',
                        type: 'header'
                    },
                    {
                        display: 'Background Color',
                        group,
                        name: 'backgroundColor',
                        showAlpha: false,
                        type: 'color'
                    },
                    {
                        display: 'Button Color',
                        group,
                        name: 'buttonColor',
                        showAlpha: false,
                        type: 'color',
                        value: TypeConfig.defaultBackgroundColor
                    },
                    {
                        display: 'Border Radius',
                        group,
                        name: 'borderRadius',
                        options: TypeConfig.options.measurement(true),
                        type: 'measurement',
                        value: { value: '3', unit: 'px' }
                    },
                    {
                        display: 'Border',
                        group,
                        name: 'border',
                        options: TypeConfig.options.measurement(),
                        type: 'border'
                    },
                    {
                        fullWidth: true,
                        group,
                        type: 'spacer-short'
                    },
                ]
            };
        },
        layout: function () {
            const group = 'layout';
            return {
                group,
                label: 'Layout',
                options: [
                    {
                        display: 'Padding/Margin',
                        group,
                        max: '100',
                        name: 'paddingMargin',
                        options: TypeConfig.options.measurement(),
                        type: 'paddingMargin',
                        value: {
                            marginBottom: { value: '18', unit: 'px' },
                            marginLeft: { value: '18', unit: 'px' },
                            marginRight: { value: '18', unit: 'px' },
                            marginTop: { value: '18', unit: 'px' },
                            paddingBottom: { value: '15', unit: 'px' },
                            paddingLeft: { value: '15', unit: 'px' },
                            paddingRight: { value: '15', unit: 'px' },
                            paddingTop: { value: '15', unit: 'px' }
                        }
                    },
                    {
                        display: 'Full Width',
                        group,
                        name: 'fullWidth',
                        type: 'checkbox',
                        value: false
                    },
                    {
                        display: 'Button Placement',
                        group,
                        name: 'alignment',
                        options: TypeConfig.options.alignment(),
                        type: 'dropdown',
                        value: 'center',
                        visible: (config) => config.layout && !config.layout.fullWidth
                    }
                ]
            };
        }
    }
}
const BaseButton = { Component: BaseButtonComponent, TypeConfig: BaseButtonTypeConfig };

// region LINK BUTTON

function LinkButtonComponent(props) {
    let link;
    if (props.blockConfig && props.blockConfig.block && props.blockConfig.block.url) {
        link = props.blockConfig.block.url;
    }
    return <BaseButtonComponent {...props} defaultText={LinkButtonTypeConfig.defaultText()} link={link} onShouldMapStyleConfigProp={(propName) => propName != 'url'} />
}
const LinkButtonTypeConfig = {
    defaultText: () => 'Shop Now',
    panel: {
        block: function () {
            const config = BaseButtonTypeConfig.panel.block(LinkButtonTypeConfig.defaultText());
            config.options.splice(0, 0,
                {
                    display: 'Button Link',
                    group: config.group,
                    name: 'url',
                    fullWidth: true,
                    type: 'text'
                }
            );
            return config;
        },
        layout: BaseButtonTypeConfig.panel.layout
    }
}
const LinkButtonBlockTypeDefinition = (group) => {
    return {
        id: Name.Block.LinkButton,
        config: {
            block: LinkButtonTypeConfig.panel.block(),
            layout: LinkButtonTypeConfig.panel.layout()
        },
        display: 'Button',
        group,
        image: 'button.png'
    };
}
const LinkButton = { BlockTypeDefinition: LinkButtonBlockTypeDefinition, Component: LinkButtonComponent, TypeConfig: LinkButtonTypeConfig };

export { BaseButton, LinkButton }